// extracted by mini-css-extract-plugin
module.exports = {"Container":"ResultsCounter_Container__1ANMM","Text":"ResultsCounter_Text__3uRM6","Link":"ResultsCounter_Link__1tZFw"};